import React, { Component, PropTypes } from "react";
// import ReactHighcharts from 'react-highcharts';

import config from "./ChartTelematicsConfig";
import { NitroLoading, NitroContentNotAvailable } from "nitro-components";

import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import RHC from "react-highcharts";

import HighchartsMore from "highcharts/highcharts-more";
import { merge } from "lodash";

import styled from "styled-components";

let chartInstance;
HighchartsMore(Highcharts);
exporting(Highcharts);

const ReactHighcharts = RHC.withHighcharts(Highcharts);

class ChartSpiderWeb extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chart: null
    };
  }

  componentDidMount() {
    chartInstance = this.refs.chart.getChart();
  }

  componentDidUpdate() {
    chartInstance = this.refs.chart.getChart();
    chartInstance.reflow = () => {};
  }

  export = option => {
    const { data } = this.props;

    const chart = this.refs.chart;
    chart.getChart().exportChart(option);
  };

  afterRender = chart => {
    // console.log(chart);
  };

  render() {
    const { data, plotOptions, disableDataPoints } = this.props;

    if (data) {
      const chartConfig = Object.assign({}, config, {
        title: "",
        xAxis: {
          categories: data.Categories,
          tickmarkPlacement: "on",
          lineWidth: 0
        },

        tooltip: {
          enabled: disableDataPoints ? false : true
        },

        series: [
          {
            data: data.Data,
            pointPlacement: "on",
            color: "#B9B309",
            fillColor: "rgba(185, 179, 9, 0.4)",
            fillOpacity: 0.5
          }
        ]
      });

      return (
        <ReactHighcharts
          ref="chart"
          config={chartConfig}
          callback={this.afterRender}
        />
      );
    } else {
      return <NitroLoading center thickness={2} size={24} />;
    }
  }
}

ChartSpiderWeb.propTypes = {
  exportOptions: PropTypes.object,
  plotOptions: PropTypes.object,
  disableDataPoints: PropTypes.bool,
  data: PropTypes.object.isRequired,
  error: PropTypes.bool // TODO .isRequired
};

export default ChartSpiderWeb;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartSpiderWeb.js